import { useEffect } from 'preact/hooks';
import { api } from './api';
import { ui } from './store';

const OPTION_ICON: Record<string, string> = { quest: '◆', turnin: '✔', service: '⚙', bye: '✕', bond: '♥' };

/** Close-range NPC dialogue: letterbox band, name, line, options. */
export function Dialogue() {
  const d = ui.dialogue.value;
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const cur = ui.dialogue.value;
      if (!cur) return;
      if (e.code === 'KeyG' || e.code === 'Space' || e.code === 'Enter') {
        e.preventDefault();
        e.stopPropagation();
        if (cur.index < cur.lines.length - 1) ui.dialogue.value = { ...cur, index: cur.index + 1 };
        else if (cur.options.length === 1) api().dialogueOption(cur.options[0] as (typeof cur.options)[number]);
      } else if (e.code === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        api().closeDialogue();
      }
    };
    window.addEventListener('keydown', onKey, true);
    return () => window.removeEventListener('keydown', onKey, true);
  }, []);
  if (!d) return null;
  const last = d.index >= d.lines.length - 1;
  return (
    <div class="dialogue interactive" onPointerDown={(e) => e.stopPropagation()}>
      <div class="dlg-band">
        <div class="dlg-role">[{d.role}]</div>
        <div class="dlg-name">{d.name}</div>
        <div class="dlg-line">{d.lines[d.index] ?? ''}</div>
        {!last && (
          <button class="dlg-next" onClick={() => (ui.dialogue.value = { ...d, index: d.index + 1 })}>
            Next <span class="keycap">G</span>
          </button>
        )}
      </div>
      {last && d.options.length > 0 && (
        <div class="dlg-options">
          {d.options.map((o, i) => (
            <button key={i} class={`dlg-opt ${o.kind}`} onClick={() => api().dialogueOption(o)}>
              <span class="dlg-ic">{OPTION_ICON[o.kind] ?? '•'}</span>
              {o.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
